export default __webpack_public_path__ + "static/media/6.a97e2a08.jpg";